<template>
  <div id="divLogin">
    <div id="BGImages">
      <img src="../assets/images/BGImages/BG1.jpg" />
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        width: 100%;
        flex-wrap: wrap;
        top: 50px;
        postiion: relative;
      "
      v-if="isBrowserCompatibility"
    >
      <div
        v-if="!hideBg"
        id="CoLogoBlock"
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          jsutify-content: center;
          background-color: #f8f8ff94;
        "
      >
        <img src="../assets/Login/Logoa.png" class="imgHeight" />
      </div>
      <div
        id="LoginBlock"
        style="
          color: Black;
          min-height: 160px;
          width: 98%;
          background-color: #f8f8ff94;
        "
        v-if="!hideBg"
      >
        <div class="Flex_Table Wrap" DefaultButton="btnTokenAuth">
          <div class="Flex_Row" style="padding-bottom: 5px">
            <div class="Flex_Cell" width="50%" style="padding-right: 5px" v-if="loginTypeID == 1">
              <span class="DataIcon glyphicons user"></span>
              <!-- <span
                title="For Getting OTP, Type Mobile number"
                class="Button"
                style="color: rgb(0 4 126)"
                @click="sendOTP()"
                v-if="loginTypeID == 1"
                ><input type="button" id="btnTokenAuth" value="GET OTP" /></span
              >-->
              <input
                type="button"
                class="Button"
                id="btnTokenAuth"
                @click="sendOTP()"
                style="margin: 0px; font-size: smaller"
                value="GET OTP"
              />
              <input
                type="text"
                id="txtLogin"
                v-model="loginName"
                placeholder="Enter Email / Mobile"
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </div>
            <div class="Flex_Cell" v-else width="34%" style="padding-right: 5px">
              <span class="DataIcon glyphicons user"></span>
              <input
                type="text"
                id="txtLogin"
                v-model="loginName"
                placeholder="Enter Email / Mobile"
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </div>
            <div class="Flex_Cell" style="padding-right: 5px" width="33%" v-if="loginTypeID == 3">
              <span class="DataIcon glyphicons keys" style="color: black"></span>
              <input
                type="password"
                id="txtPassword"
                name="txtPassword"
                placeholder="Enter Password"
                v-model="loginPassword"
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </div>
            <div class="Flex_Cell" style="padding-right: 5px" width="33%" v-if="loginTypeID == 2">
              <span class="DataIcon glyphicons phone" style="color: black"></span>
              <input
                type="button"
                class="resendBtn"
                id="btnTokenAuth"
                @click="generateForgotOTP(2)"
                style="margin: 0px; font-size: smaller"
                v-if="isDisabled == false"
                value="RESEND"
              />
              <input
                type="password"
                id="txtOTP"
                name="txtOTP"
                placeholder="Enter OTP"
                v-model="loginOTP"
                v-on:keyup.enter="authenticateUser(loginTypeID)"
                maxlength="6"
                autocomplete="off"
                readonly
                regExp="([0-9])*"
                onfocus="this.removeAttribute('readonly');"
              />
              <!-- <span
                class="Button"
                style="color: rgb(0 4 126)"
                v-if="isDisabled == false"
                @click="generateForgotOTP(2)"
                >Resend OTP</span
              >-->
              <div
                class="Flex_Row Resend"
                valign="middle"
                align="right"
                v-if="loginTypeID == 2 && OtpCaptchaID == 0"
              >
                <span>
                  <b>
                    Resend OTP after
                    {{
                    this.minutesLeft +
                    ":" +
                    (this.secondsLeft > 9
                    ? this.secondsLeft
                    : "0" + this.secondsLeft)
                    }}
                  </b>
                </span>
              </div>
            </div>
            <div class="Flex_Cell" width="33%" v-if="OtpCaptchaID == 1">
              <span
                class="DataIcon glyphicons refresh"
                style="cursor: pointer"
                v-on:click="generateCaptcha(4, 80, 18)"
              ></span>
              <img
                id="imgCaptchaForResendOTP"
                style="border: 0px solid #000; border-radius: 12px"
                class="Captcha2"
              />
              <input
                type="text"
                v-model="captchaValueforResendOTP"
                v-on:keyup.enter="generateForgotOTP(2)"
                placeholder="Captcha"
                maxlength="6"
              />
            </div>
            <div class="Flex_Cell" width="33%" v-if="loginTypeID == 3">
              <span
                class="DataIcon glyphicons refresh"
                style="cursor: pointer"
                v-on:click="generateCaptcha(7, 80, 16)"
              ></span>
              <img
                id="imgCaptchaForLogin"
                style="border: 0px solid #000; border-radius: 12px"
                class="Captcha1"
              />
              <input
                type="text"
                v-model="captchaValueforLogin"
                v-on:keyup.enter="authenticateUser(loginTypeID)"
                placeholder="Captcha"
                maxlength="6"
              />
            </div>
            <div class="Flex_Cell" width="50%" v-if="loginTypeID == 1">
              <span
                class="DataIcon glyphicons refresh"
                style="cursor: pointer"
                v-on:click="generateCaptcha(3, 100, 17)"
              ></span>
              <img
                id="imgCaptchaForGetOTP"
                style="border: 0px solid #000; border-radius: 12px"
                class="Captcha"
              />
              <input
                type="text"
                v-model="captchaValueforGetOTP"
                v-on:keyup.enter="sendOTP()"
                placeholder="Captcha"
                maxlength="6"
              />
            </div>
          </div>
          <div
            class="Flex_Row"
            valign="middle"
            align="center"
            v-if="loginTypeID == 1"
            style="
              padding-bottom: 5px;
              color: white;
              font-weight: bold;
              text-shadow: 1px 1px 2px #000, 0 0 25px #151515, 0 0 5px #131313;
            "
          >
            <span style>
              Login Using
              <u>
                <a @click="changeLoginType(1)">Password</a>
              </u>
            </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>
              Tour Operator
              <u>
                <a @click="signUp()">Sign up</a>
              </u>
            </span>
            <br />
            <br />
            <br />
          </div>
          <div
            class="Flex_Row"
            v-if="loginTypeID == 2"
            valign="middle"
            align="right"
            style="padding-bottom: 5px; color: rgb(0 4 126)"
          >
            <div class="Flex_Cell" align="center" valign="middle" style="top: 2px">
              <input
                type="button"
                id="btnTokenAuth"
                value="Login"
                v-on:click="authenticateUser(loginTypeID)"
              />
              <input type="button" value="Cancel" v-on:click="clearPage()" />
            </div>
          </div>
          <div
            class="Flex_Row"
            v-if="loginTypeID == 3"
            valign="middle"
            align="center"
            style="
              padding-bottom: 5px;
              color: white;
              font-weight: bold;
              text-shadow: 1px 1px 2px #000, 0 0 25px #151515, 0 0 5px #131313;
            "
          >
            <div class="Flex_Cell" align="center" valign="middle" style="width: 35%; top: 0px">
              <input
                type="button"
                id="btnTokenAuth"
                value="Login"
                v-on:click="authenticateUser(loginTypeID)"
              />
            </div>
            <b>
              <span>
                Login Using
                <u>
                  <a @click="changeLoginType(2)">Mobile</a>
                </u>
              </span>
            </b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>
              <span>
                <u>
                  <a @click="forgetPasswordView()">Forgot Password</a>
                </u>
              </span>
            </b>
          </div>
        </div>
      </div>
      <div id="CreateLoginBlock" v-if="createNewAccountdiv">
        <div class="Flex_Table CreateLoginBlockHeader">
          <div class="Flex_Row">
            <div class="Flex_Cell" width="80%">
              <span>Registration Form</span>
            </div>
          </div>
        </div>
        <div class="CreateLoginContent">
          <!-- <div class="Flex_Table">
            <div class="Flex_Row">
              <div class="Flex_Cell">
                <div class="Flex_Table Instruction">
                  <div class="Flex_Row">
                    <div class="Flex_Cell">
                      <span style="font-size: medium; font-weight: bold">
                        Guidelines to fill the application form
                      </span>
                    </div>
                  </div>
                  <div class="Flex_Row instructionRow">
                    <div class="Flex_Cell">
                      <span style="color: Blue; font-weight: bold">1.</span>
                      Candidates are requested to read the instructions
                      carefully before filling up online application. To
                      facilitate the candidates, specimen of application form
                      (including Registration process) is made available on
                      <b>“Candidates”</b> corner on the website
                      <a style="color: blue">www.aocrecruitment.gov.in</a>.
                      Stagewise guidelines to fill online application form are
                      elaborated here.
                    </div>
                  </div>
                  <div class="Flex_Row instructionRow">
                    <div class="Flex_Cell">
                      <span style="color: Blue; font-weight: bold">2.</span>
                      Name and Date of Birth should be as mentioned in
                      Matriculation Certificate or equivalent issued by
                      recognised Education Board.
                    </div>
                  </div>
                  <div class="Flex_Row instructionRow">
                    <div class="Flex_Cell">
                      <span style="color: Blue; font-weight: bold">3.</span>
                      Candidates should note that only the date of birth as
                      recorded in the matriculation, higher secondary
                      examination certificate or an equivalent certificate
                      recognised by State/central board provided on the date of
                      submission of application will be accepted for determining
                      the age eligibility and no subsequent request for its
                      change will be considered or granted.
                    </div>
                  </div>
                  <div class="Flex_Row instructionRow">
                    <div class="Flex_Cell">
                      <span style="color: Blue; font-weight: bold">4.</span>
                      <b> Mobile Number & email ID.</b> Registration process is
                      made by verifying Mobile Number and eMail ID through OTP.
                      All further communication will be made on the Mobile
                      Number and email ID recorded at the time of Registration.
                      Hence, candidates are advised to fill valid mobile number
                      and email ID only and not to change their Mobile Number
                      and email ID.
                    </div>
                  </div>
                  <div class="Flex_Row instructionRow">
                    <div class="Flex_Cell">
                      <span style="color: Blue; font-weight: bold">5.</span>
                      <b> Password.</b> Candidates are advised in their own
                      interest not to share their password.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <div class="Flex_Table Wrap" width="100%">
            <div class="Flex_Row">
              <div class="Flex_Cell" width="48%">
                <span>User Type</span>
                <span style="color: red; font-weight: bold">*</span>
                <select class="CreateAccount" id="ddlUserType" v-model="userTypeID">
                  <option
                    v-for="m in userTypeList"
                    :key="m.userTypeID"
                    v-bind:value="m.userTypeID"
                  >{{ m.userTypeName }}</option>
                </select>
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="48%">
                <span>Title</span>
                <span style="color: red; font-weight: bold">*</span>
                <!-- <select class="CreateAccount" v-model="rankID">
                  <option value="1">Mr.</option>
                  <option value="2">Ms.</option>
                </select>-->
                <select class="CreateAccount" id="ddlMemberTitle" v-model="rankID">
                  <option v-for="m in memberTitleList" :key="m[0]" v-bind:value="m[0]">{{ m[1] }}</option>
                </select>
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" width="48%">
                <span>First Name</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="fName"
                  type="textbox"
                  :isRequired="true"
                  placeholder="PLEASE ENTER YOUR FIRST NAME"
                  v-model="fName"
                  class="CreateAccount"
                />
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="48%">
                <span>Middle Name</span>
                <AcceptInput
                  maxlength="112"
                  ref="mName"
                  type="textbox"
                  placeholder="PLEASE ENTER YOUR MIDDLE NAME"
                  v-model="mName"
                  class="CreateAccount"
                />
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" width="48%">
                <span>Last Name</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="lName"
                  type="textbox"
                  :isRequired="true"
                  placeholder="PLEASE ENTER YOUR LAST NAME"
                  v-model="lName"
                  class="CreateAccount"
                />
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="48%">
                <span>
                  Date of Birth
                  <!--<span style="color: red"
                    >[As given in Matriculation Certificate]</span
                  >
                   <br />
                  [ { {{ dOBCheckList.minDateFormat }} } - {
                  {{ dOBCheckList.maxDateFormat }} } ]-->
                </span>
                <!-- <span style="color: red; font-weight: bold">*</span> -->
                <DateControl style="width: 100%" v-model="dob"></DateControl>
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" width="48%">
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div class="Flex_Cell">
                      <span>Mobile No.</span>
                      <span style="color: red; font-weight: bold">*</span>
                      <AcceptInput
                        maxlength="10"
                        style="padding-left:0 padding-right:0"
                        ref="userMobile"
                        type="textbox"
                        v-model="userMobile"
                        :isRequired="true"
                        placeholder="PLEASE ENTER YOUR MOBILE NO."
                        class="CreateAccount"
                        regExp="([0-9])*"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="48%">
                <span>Email (Login Name)</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="userEmail"
                  type="email"
                  :isRequired="true"
                  placeholder="PLEASE ENTER YOUR EMAIL"
                  v-model="userEmail"
                  class="CreateAccount"
                />
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" width="48%">
                <span>Password</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="userPassword"
                  type="password"
                  :isRequired="true"
                  placeholder="PLEASE ENTER YOUR PASSWORD"
                  v-model="userPassword"
                  class="CreateAccount"
                  @keyup="checkPasswordStrength($event)"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                />
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="48%">
                <span>Confirm Password</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="confirmPassword"
                  type="password"
                  :isRequired="true"
                  placeholder="PLEASE CONFIRM YOUR PASSWORD"
                  v-model="confirmPassword"
                  @keyup="confirmPasswordMatch($event, 1)"
                  class="CreateAccount"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                />
              </div>
            </div>
            <div class="Flex_Row" style="margin-bottom: 5px">
              <div class="Flex_Cell" width="48%">
                <span>Gender</span>
                <span style="color: red; font-weight: bold">*</span>
                <select class="CreateAccount" id="ddlUserType" v-model="gender">
                  <option v-for="g in genderList" :key="g[0]" v-bind:value="g[2]">{{ g[1] }}</option>
                </select>
                <!-- <span>Gender</span>
                <span style="color: red; font-weight: bold">*</span>-->
                <!-- <div style="margin-top: 8px">
                  <input
                    id="rblGender_0"
                    v-model="gender"
                    type="radio"
                    name="rblGender"
                    value="M"
                    checked="checked"
                    class="rblgender"
                  />
                  <label for="rblGender_0" class="lblClass">Male</label>
                  &nbsp;
                  <input
                    id="rblGender_1"
                    v-model="gender"
                    type="radio"
                    name="rblGender"
                    value="F"
                    class="rblgender"
                  />
                  <label for="rblGender_1" class="lblClass">Female</label>
                  &nbsp;
                  <input
                    id="rblGender_2"
                    v-model="gender"
                    type="radio"
                    name="rblGender"
                    value="T"
                    class="rblgender"
                  />
                  <label for="rblGender_2" class="lblClass">Transgender</label>
                </div>-->
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="48%">
                <div class="Flex_Table Wrap" width="100%">
                  <div class="Flex_Row">
                    <div class="Flex_Cell" width="40%" style="margin-top: 6px">
                      <span>Captcha</span>
                      <span style="color: red; font-weight: bold">*</span>
                      <input
                        type="text"
                        v-model="captchaValue"
                        style="padding: 10px 20px"
                        maxlength="6"
                      />
                    </div>
                    <div class="Flex_Cell" width="3%"></div>
                    <div class="Flex_Cell" valign="bottom">
                      <img id="imgCaptcha" style="border: 1px solid #000" />
                    </div>
                    <div class="Flex_Cell" width="6%" valign="bottom">
                      <img
                        src="../assets/images/refresh.png"
                        v-on:click="generateCaptcha(1, 120, 50)"
                        style="
                          cursor: pointer;
                          border: 1px solid #000;
                          border-radius: 50%;
                        "
                        title="Click here to refresh captcha"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <hr />
          </div>
          <div class="Flex_Table Wrap" width="100%">
            <div class="Flex_Row">
              <div class="Flex_Cell" style="text-align: center" width="100%">
                <input type="button" value="Register Login" v-on:click="createNewUser()" />
                <input type="button" value="Cancel" v-on:click="hideCreateAccount()" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalPopup
        title="User Activation Pending! Please Verify OTP"
        ref="ModalPopup2"
        @closed="modalPopupClosed"
        @opened="modalPopupShown"
        v-model="isVerifyOTPReq"
        :okButton="$refs.btnOk"
        :cancelButton="$refs.btnOk"
      >
        <div id="dvVerifyOTP" v-if="isVerifyOTPReq">
          <div class="Flex_Table CreateLoginContent">
            <div class="Flex_Row" v-if="isEMailOTPRequired == 1">
              <div class="Flex_Cell" style="width: 72%">
                Email
                <span style="color: red; font-weight: bold">*</span>
              </div>
              <div class="Flex_Cell" style="width: 4%"></div>
              <div class="Flex_Cell" style="width: 24%" v-if="btnName != 'Generate OTP'">
                OTP
                <span style="color: red; font-weight: bold">*</span>
              </div>
            </div>
            <div class="Flex_Row" v-if="isEMailOTPRequired == 1">
              <div class="Flex_Cell" style="width: 72%">
                <AcceptInput
                  maxlength="112"
                  ref="emailID"
                  type="email"
                  :isRequired="true"
                  placeholder="PLEASE ENTER YOUR EMAIL"
                  v-model="verifyEmail"
                  class="CreateAccount"
                  :disabled="true"
                />
              </div>
              <div class="Flex_Cell" style="width: 4%"></div>
              <div class="Flex_Cell" style="width: 24%" v-if="btnName != 'Generate OTP'">
                <AcceptInput
                  maxlength="6"
                  style="padding-left:0 padding-right:0"
                  ref="emailOTP"
                  type="textbox"
                  v-model="emailOTP"
                  :isRequired="true"
                  class="CreateAccount"
                  placeholder="OTP"
                  regExp="([0-9])*"
                />
              </div>
            </div>
            <div class="Flex_Row" v-if="isMobileOTPRequired == 1" style="margin-top: 10px">
              <div class="Flex_Cell" style="width: 72%">
                Mobile
                <span style="color: red; font-weight: bold">*</span>
              </div>
              <div class="Flex_Cell" style="width: 4%"></div>
              <div class="Flex_Cell" style="width: 24%" v-if="btnName != 'Generate OTP'">
                OTP
                <span style="color: red; font-weight: bold">*</span>
              </div>
            </div>
            <div class="Flex_Row" v-if="isMobileOTPRequired == 1">
              <div class="Flex_Cell" style="width: 72%">
                <AcceptInput
                  maxlength="10"
                  style="padding-left:0 padding-right:0"
                  ref="mobile"
                  type="textbox"
                  v-model="verifyMobile"
                  :isRequired="true"
                  placeholder="PLEASE ENTER YOUR MOBILE NO."
                  class="CreateAccount"
                  regExp="([0-9])*"
                  :disabled="true"
                />
              </div>
              <div class="Flex_Cell" style="width: 4%"></div>
              <div class="Flex_Cell" style="width: 24%" v-if="btnName != 'Generate OTP'">
                <AcceptInput
                  maxlength="6"
                  style="padding-left:0 padding-right:0"
                  ref="mobileOTP"
                  type="textbox"
                  v-model="mobileOTP"
                  :isRequired="true"
                  class="CreateAccount"
                  placeholder="OTP"
                  regExp="([0-9])*"
                />
              </div>
            </div>
            <div class="Flex_Row" style="width: 30%">
              <span>captcha</span>
              <span style="color: red; font-weight: bold">*</span>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" style="width: 30%">
                <input
                  type="text"
                  v-model="captchaValueForMobEmailVerification"
                  style="padding: 10px 20px"
                  maxlength="6"
                />
              </div>
              <div class="Flex_Cell" style="width: 30%" valign="middle">
                <img
                  id="imgCaptchaForMobEmailVerification"
                  style="border: 1px solid #000; height: 100%"
                />
              </div>
              <div class="Flex_Cell" style="width: 30%" valign="middle">
                <img
                  src="../assets/images/refresh.png"
                  v-on:click="generateCaptcha(5, 120, 50)"
                  style="
                    cursor: pointer;
                    height: 25px;
                    border: 1px solid #000;
                    border-radius: 50%;
                  "
                  title="Click here to refresh captcha"
                />
              </div>
            </div>
            <div class="Flex_Row" align="center">
              <div class="Flex_Cell" style="width: 72%">
                <input
                  type="button"
                  v-model="btnName"
                  v-on:click="generateForgotOTP(1)"
                  :disabled="isDisabled"
                />
                <span v-if="isOTPTimeLeft">
                  Resend OTP after
                  {{
                  this.minutesLeft +
                  ":" +
                  (this.secondsLeft > 9
                  ? this.secondsLeft
                  : "0" + this.secondsLeft)
                  }}
                </span>
              </div>
              <div class="Flex_Cell" style="width: 4%"></div>
              <div class="Flex_Cell" style="width: 24%" v-if="btnName != 'Generate OTP'">
                <input type="button" value="Verify OTP" v-on:click="verifyOTP(1)" />
              </div>
            </div>
          </div>
          <div class="Flex_Table" style="padding: 5px" v-if="eMailOTPRef != ''">
            <div class="Flex_Row" v-if="!IsEMailActivated">
              <div class="Flex_Cell">
                EMAIL:
                <span>
                  OTP is sent in your email with
                  <b>{{ eMailOTPRef }}</b> ref
                  id
                </span>
              </div>
            </div>
            <div class="Flex_Row" v-if="!IsMobileActivated">
              <div class="Flex_Cell">
                MOBILE:
                <span>
                  OTP is sent in your mobile with
                  <b>{{ mobileOTPRef }}</b> ref
                  id
                </span>
              </div>
            </div>
          </div>
        </div>
      </ModalPopup>
      <ModalPopup
        title="Forgot Password"
        ref="ModalPopup1"
        @closed="modalPopupClosed"
        @opened="modalPopupShown"
        v-model="forgotPassworddiv"
        :okButton="$refs.btnOk"
        :cancelButton="$refs.btnOk"
      >
        <div id="CreateLoginBlock" v-if="forgotPassworddiv" style="width: 100%">
          <div class="CreateLoginContent">
            <div class="Flex_Table">
              <div class="Flex_Row">
                <div class="Flex_Cell" style="padding: 5px !important">
                  <div class="Flex_Table" v-if="!forgotVerification">
                    <div class="Flex_Row" v-if="false">
                      <div class="Flex_Cell">
                        <span>Email</span>
                        <span style="color: red; font-weight: bold">*</span>
                      </div>
                    </div>
                    <div class="Flex_Row" v-if="false">
                      <div class="Flex_Cell">
                        <AcceptInput
                          maxlength="112"
                          ref="forgotLogin"
                          type="email"
                          :isRequired="true"
                          placeholder="PLEASE ENTER YOUR EMAIL "
                          v-model="forgotLogin"
                          class="CreateAccount"
                        />
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell">
                        <span>Mobile Number</span>
                        <span style="color: red; font-weight: bold">*</span>
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell">
                        <AcceptInput
                          maxlength="10"
                          style="padding-left:0 padding-right:0"
                          ref="forgotMobile"
                          type="textbox"
                          v-model="forgotMobile"
                          :isRequired="true"
                          placeholder="PLEASE ENTER YOUR MOBILE NO."
                          class="CreateAccount"
                          regExp="([0-9])*"
                        />
                      </div>
                    </div>
                    <div class="Flex_Row" v-show="OtpForgetPassCaptchaID != 0">
                      <div class="Flex_Cell" style="width: 40%">
                        <span>Captcha</span>
                        <span style="color: red; font-weight: bold">*</span>
                      </div>
                    </div>
                    <div class="Flex_Row" v-show="OtpForgetPassCaptchaID != 0">
                      <div class="Flex_Cell" style="width: 40%">
                        <input
                          type="text"
                          v-model="captchaValueForForgetPass"
                          style="padding: 10px 20px"
                          maxlength="6"
                        />
                      </div>
                      <div
                        class="Flex_Cell"
                        style="width: 30%; padding-left: 10px; margin-left: 10px"
                      >
                        <img
                          id="imgCaptchaForForgetPass"
                          style="border: 1px solid #000; height: 80%"
                        />
                      </div>
                      <div
                        class="Flex_Cell"
                        align="left"
                        style="
                    width: 30%;
                    padding-top: 6px;
                    padding-left: 0px;
                    margin-left: 10px;
                  "
                      >
                        <img
                          src="../assets/images/refresh.png"
                          v-on:click="generateCaptcha(6, 120, 50)"
                          style="
                      cursor: pointer;
                      height: 25px;
                      border: 1px solid #000;
                      border-radius: 50%;
                    "
                          title="Click here to refresh captcha"
                        />
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell" align="center" v-if="!forgotOTPSend">
                        <input
                          type="button"
                          value="Generate OTP"
                          v-on:click="verifyForgotPasswordAuth()"
                          :disabled="isDisabled"
                        />
                      </div>
                      <div class="Flex_Cell" align="center" v-if="forgotOTPSend">
                        <input
                          type="button"
                          value="Resend OTP"
                          v-on:click="generateForgotPasswordOTP()"
                          :disabled="isDisabled"
                        />
                      </div>
                      <div class="Flex_Cell" valign="middle" v-if="forgotOTPSend">
                        <span>
                          Resend OTP after
                          {{
                          this.minutesLeft +
                          ":" +
                          (this.secondsLeft > 9
                          ? this.secondsLeft
                          : "0" + this.secondsLeft)
                          }}
                        </span>
                      </div>
                    </div>
                    <!-- <div class="Flex_Row" v-if="forgotOTPSend">
                <div class="Flex_Cell" align="center">
                  <input type="button" value="Verify OTP" v-on:click="verifyOTP(2)" />
                </div>
                    </div>-->
                  </div>
                </div>
                <div class="Flex_Cell" style="padding: 5px !important" v-if="forgotOTPSend">
                  <!-- <div class="Flex_Table" v-if="eMailOTPRef != ''">
                    <div class="Flex_Row" v-if="eMailOTPRef != ''">
                      <div class="Flex_Cell" v-if="false">
                        EMAIL:
                        <span>
                          OTP is sent in your email with
                          <b>{{ eMailOTPRef }}</b> ref
                          id
                        </span>
                      </div>
                    </div>
                    <div class="Flex_Row" v-if="mobileOTPRef != ''">
                      <div class="Flex_Cell">
                        MOBILE:
                        <span>
                          OTP is sent in your mobile with
                          <b>{{ mobileOTPRef }}</b> ref id
                        </span>
                      </div>
                    </div>
                  </div>-->
                  <div class="Flex_Table" v-if="forgotOTPSend">
                    <div class="Flex_Row" v-if="forgotOTPSend">
                      <div class="Flex_Cell">
                        <span>OTP</span>
                        <span style="color: red; font-weight: bold">*</span>
                        <span v-if="mobileOTPRef != ''">
                          OTP is sent in your mobile with
                          <b>{{ mobileOTPRef }}</b> ref id
                        </span>
                      </div>
                    </div>
                    <div class="Flex_Row" v-if="forgotOTPSend">
                      <div class="Flex_Cell">
                        <AcceptInput
                          maxlength="6"
                          ref="forgotOTP"
                          type="textbox"
                          :isRequired="true"
                          placeholder="PLEASE ENTER YOUR OTP"
                          v-model="forgotOTP"
                          class="CreateAccount"
                        />
                      </div>
                    </div>
                    <!-- v-if="forgotVerification"> -->
                    <div class="Flex_Row">
                      <div class="Flex_Cell">
                        <span>New Password</span>
                        <span style="color: red; font-weight: bold">*</span>
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell">
                        <input
                          maxlength="112"
                          type="password"
                          :isRequired="true"
                          placeholder="PLEASE ENTER YOUR NEW PASSWORD"
                          v-model="newPassword"
                          class="CreateAccount"
                          readonly
                          onfocus="this.removeAttribute('readonly');"
                          @keyup="checkPasswordStrength($event)"
                        />
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell">
                        <span>Confirm Password</span>
                        <span style="color: red; font-weight: bold">*</span>
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell">
                        <input
                          maxlength="112"
                          type="password"
                          :isRequired="true"
                          @keyup="confirmPasswordMatch($event, 2)"
                          placeholder="PLEASE CONFIRM YOUR NEW PASSWORD"
                          readonly
                          onfocus="this.removeAttribute('readonly');"
                          v-model="newConfirmPassword"
                          class="CreateAccount"
                        />
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell">
                        <span>Captcha</span>
                        <span style="color: red; font-weight: bold">*</span>
                      </div>
                      <div class="Flex_Cell"></div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell" style="width: 40%">
                        <input
                          type="text"
                          v-model="captchaValueforPwd"
                          style="padding: 10px 20px"
                          maxlength="6"
                        />
                      </div>
                      <div class="Flex_Cell" style="width: 2%"></div>
                      <div class="Flex_Cell">
                        <img id="imgCaptchaForPwd" style="width: 51%; border: 1px solid #000" />
                        <img
                          src="../assets/images/refresh.png"
                          v-on:click="generateCaptcha(2, 120, 50)"
                          style="
                      cursor: pointer;
                      height: 25px;
                      border: 1px solid #000;
                      border-radius: 50%;
                    "
                          title="Click here to refresh captcha"
                        />
                      </div>
                    </div>
                    <br />
                    <hr />
                    <div class="Flex_Row">
                      <div class="Flex_Cell" style="text-align: center">
                        <input type="button" v-model="resetPWD" v-on:click="setNewPassword()" />
                        <input type="button" value="Cancel" v-on:click="hideCreateAccount()" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalPopup>
    </div>
    <div id="divBrowserNotSupported" v-if="!isBrowserCompatibility" class="browserDiv">
      Your Browser Version Not Supported! Please Update.
      <br />Supported Browsers are :
      <div>
        <img src="../assets/images/ie.png" style="width: 24px; vertical-align: middle" />
        Internet Explorer 11+/edge,
      </div>
      <div>
        <img src="../assets/images/chrome.png" style="width: 24px; vertical-align: middle" />
        Google Chrome 60+,
      </div>
      <div>
        <img src="../assets/images/firefox.png" style="width: 24px; vertical-align: middle" />
        Mozilla FireFox 60+,
      </div>
      <div>
        <img src="../assets/images/opera.png" style="width: 24px; vertical-align: middle" />
        Opera 60+.
      </div>
    </div>
    <div id="divBrowserInfo"></div>
    <div class="Flex_Table tblEntryForm companyLogo">
      <div class="Flex_Row">
        <div class="Flex_Cell" align="center" style="width: 100%">
          &copy; Border Roads Organisation {{ curYear }} / All rights reserved.
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span
            style="cursor: pointer"
            v-on:click="redirectToWebSite()"
          >Developed by Ekklavya</span>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
@import url("../assets/css/Login_v1.0.css");
@import url("../assets/css/Theme/main_v1.0.css");
@import url("../assets/css/Theme/Desktop_v1.0.css");
@import url("../assets/css/Theme/Mobile_Landscape_v1.0.css");
@import url("../assets/css/Theme/Mobile_Portrait_v1.0.css");

#CreateLoginBlock {
  min-height: 300px;
  background-color: rgba(255, 255, 255, 0.99) !important;
  border-radius: 10px;
  width: 830px;
  height: 100%;
  padding: 10px;
}

.CreateLoginBlockHeader {
  width: 100%;
  color: black;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 18px;
  border-radius: 3px;
  text-align: center;
}

.CreateLoginContent {
  width: 100%;
  height: 100%;
  color: black;
  border: 1px solid #000;
  padding: 2px 9px 6px 9px;
}

.CreateAccount {
  width: 100%;
  padding: 10px 20px;
  margin: 4px 0;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: aliceblue;
}

#CreateLoginBlock .DataIcon {
  position: relative;
  top: 32px;
  left: 9px;
}

.rblGender input[type="radio"] {
  position: fixed;
  width: 0;
  cursor: pointer;
  opacity: 0.55;
}

.lblClass {
  display: inline;
  padding: 3px 3px 3px 3px;
  border: solid 1px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 15px;
}

.lblClass:hover {
  background-color: rgba(1, 166, 248, 0.726);
}

.makeUpperCase {
  text-transform: uppercase;
}

@media screen and (max-width: 1023px) {
  #CreateLoginBlock {
    min-height: 300px;
    background-color: rgba(255, 255, 255, 0.95) !important;
    border-radius: 10px;
    width: 99vw;
  }
}

.Instruction {
  border: solid 1px black;
  padding: 8px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.AnchorOTP {
  font-weight: 700;
  color: blue;
  text-decoration: underline;
}

.CreateLoginContent .Flex_Cell,
.CreateLoginContent .Flex_Cell_Inline {
  padding: 0px 0px !important;
}

#dvVerifyOTP {
  min-height: 250px;
  background-color: rgba(255, 255, 255, 0.99) !important;
  border-radius: 10px;
  width: 550px;
  height: 100%;
  padding: 10px;
}

.browserDiv {
  width: 650px;
  height: 220px;
  background-color: red;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  font-size: x-large;
  padding: 25px;
  border-radius: 25px;
}

.companyLogo {
  position: sticky;
  color: white;
  font-weight: bold;
  text-shadow: 1px 1px 2px #000, 0 0 25px #151515, 0 0 5px #131313;
  padding-bottom: 10px;
  top: 100%;
}
</style>
<script>
import axios from "axios";
import vue from "vue";
import Router from "vue-router";
import config from "@/router/globalConfig";
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import ModalPopup from "./ekkControls/ModalPopup";
import LoginJs from "./servicesJS/Login.js";
import MasterJS from "./servicesJS/Master.js";
import biometricJS from "@/router/biometric.js";

export default {
  name: "Login",
  components: {
    AcceptInput: AcceptInput,
    DateControl: DateControl,
    ModalPopup: ModalPopup
  },
  data() {
    return {
      curYear: new Date().convertToString("yyyy"),
      loginName: "",
      loginPassword: "",
      loginOTP: "",
      createNewAccountdiv: false,
      forgotPassworddiv: false,
      hideBg: false,
      rankID: 1,
      fName: "",
      mName: "",
      lName: "",
      dob: new Date("01 Jan 1900"),
      userMobile: "",
      userEmail: "",
      userPassword: "",
      confirmPassword: "",
      gender: "M",
      forgotLogin: "",
      forgotMobile: "",
      newPassword: "",
      newConfirmPassword: "",
      isPasswordStrenth: false,
      captchakey: "",
      captchaValue: "",
      forgotVerification: false,
      verifyCredential: "Generate OTP",
      isDisabled: false,
      resetPWD: "Reset Password",
      captchakeyforPwd: "",
      captchaValueforPwd: "",
      captchakeyforGetOTP: "",
      captchaValueforGetOTP: "",
      OtpCaptchaID: 0,
      OtpVerifyCaptchaID: 0,
      OtpForgetPassCaptchaID: 0,
      captchakeyforResendOTP: "",
      captchaValueforResendOTP: "",
      minutesLeft: 1,
      secondsLeft: 59,
      forgotOTPSend: false,
      forgotOTP: "",
      isEMailOTPRequired: false,
      isMobileOTPRequired: false,
      IsEMailActivated: false,
      IsMobileActivated: false,
      verifyEmail: "",
      verifyMobile: "",
      emailOTP: "",
      mobileOTP: "",
      isVerifyOTPReq: false,
      captchaValueForForgetPass: "",
      captchaKeyForForgetPass: "",
      captchaValueForMobEmailVerification: "",
      captchaKeyForMobEmailVerification: "",
      captchaKeyForLogin: "",
      captchaValueforLogin: "",
      btnName: "Generate OTP",
      eMailOTPRef: "",
      mobileOTPRef: "",
      isOTPTimeLeft: false,
      dOBCheckList: [],
      isBrowserCompatibility: true,
      userTypeList: [],
      userTypeID: -1,
      memberTitleList: [],
      genderList: [],
      gender: "",
      loginTypeID: 1
    };
  },
  methods: {
    redirectToWebSite() {
      let url = "http://www.eklavya.com";
      window.open(url);
    },
    clearPage() {
      this.loginTypeID = 1;
      this.loginName = "";
      this.loginPassword = "";
      this.loginOTP = "";
      this.OtpCaptchaID = 0;
      this.captchaValueforGetOTP = "";
      this.captchakeyforGetOTP = "";
      this.captchaValueForMobEmailVerification = "";
      this.captchaKeyForMobEmailVerification = "";
      this.captchaKeyForLogin = "";
      this.captchaValueforLogin = "";
      this.captchaValueForForgetPass = "";
      this.captchaKeyForForgetPass = "";
      this.captchaValueforResendOTP = "";
      this.captchakeyforResendOTP = "";
      this.generateCaptcha(3, 100, 17);
    },
    changeLoginType(type) {
      this.clearPage();
      if (type == 1) {
        this.generateCaptcha(7, 80, 16);
        this.loginTypeID = 3;
      } else {
        this.generateCaptcha(3, 100, 17);
        this.loginTypeID = 1;
      }
    },
    modalPopupClosed(e) {
      this.hideCreateAccount();
      this.clearPage();
    },
    modalPopupShown(e) {
      //console.log("Modal Popup Shown");
    },
    authenticateUser(loginType) {
      if (this.loginName == null || this.loginName.length == 0) {
        alert("PLEASE ENTER EMAIL/MOBILE");
        return false;
      }
      if (loginType == 2) {
        if (this.loginOTP == null || this.loginOTP.length == 0) {
          alert("PLEASE ENTER OTP");
          return false;
        }
      } else if (loginType == 3) {
        if (this.loginPassword == null || this.loginPassword.length == 0) {
          alert("PLEASE ENTER PASSWORD");
          return false;
        }
        if (this.captchaValueforLogin == "") {
          alert("PLEASE ENTER CAPTCHA");
          return false;
        }
      }
      var param = "";
      if (loginType == 2) {
        var encOTP = biometricJS.encryptAES(
          this.captchaKeyForLogin + "|~|" + this.loginOTP
        );
        param =
          "username=" +
          encodeURIComponent(this.loginName) +
          "&password=" +
          encodeURIComponent(encOTP) +
          "&imageID=-1&phraseID=-1&type=" +
          loginType +
          "&grant_type=password";
      } else if (loginType == 3) {
        var encPassword = biometricJS.encryptAES(
          this.captchaKeyForLogin + "|~|" + this.loginPassword
        );
        param =
          "username=" +
          encodeURIComponent(this.loginName) +
          "&password=" +
          encodeURIComponent(encPassword) +
          "&imageID=-1&phraseID=-1&type=" +
          loginType +
          "&grant_type=password&CaptchaValue=" +
          this.captchaValueforLogin +
          "&CaptchaKey=" +
          this.captchaKeyForLogin;
      }
      param += "&Token=" + config.AF_Token;
      const params = param;
      axios
        .post(config.WEB_TOKEN_PATH, params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          crossdomain: true
        })
        .then(
          result => {
            const tokenData = result.data;
            //console.log(tokenData);
            window.sessionStorage.setItem("token", tokenData.access_token);
            window.sessionStorage.setItem("token_type", tokenData.token_type);
            window.sessionStorage.setItem(
              "refresh_token",
              tokenData.refresh_token
            );
            window.sessionStorage.setItem(
              "antiforgery_token",
              tokenData.antiforgery_token
            );
            config.LOG_Token = "bearer ".concat(
              window.sessionStorage.getItem("token")
            );
            config.AF_Token = window.sessionStorage.getItem(
              "antiforgery_token"
            );
            this.isUserActivated();
            //this.$router.push({ name: "Home" });
          },
          error => {
            //console.log(error);
            vue.nextTick(() => {
              document.getElementById("txtLogin").focus();
              if (loginType == 2) {
                this.loginOTP = "";
              } else if (loginType == 3) {
                this.loginName = "";
                this.loginPassword = "";
                this.captchaValueforLogin = "";
                this.generateCaptcha(7, 80, 16);
              }
            });
            if (error.response == undefined) {
              alert("Error: " + error);
            } else {
              if (error.response.status == "401") {
                if (error.response.data.error == "invalid_grant") {
                  alert(error.response.data.error_description);
                } else if (error.response.data.error == "invalid_license") {
                  this.$router.push({ name: "License" });
                } else {
                  alert("Invalid username or password");
                }
              } else {
                alert("Error: " + error.response.statusText);
              }
            }
            window.sessionStorage.removeItem("token");
            window.sessionStorage.removeItem("token_type");
            window.sessionStorage.removeItem("refresh_token");
          },
          failure => {
            vue.nextTick(() => {
              document.getElementById("txtLogin").focus();
              this.loginName = "";
              this.loginPassword = "";
              this.loginOTP = "";
            });
            alert("Failure: " + failure);
          }
        );
    },
    signUp() {
      this.hideCreateAccount();
      this.createNewAccountdiv = true;
      this.hideBg = true;
      document.getElementById("divLogin").style.backgroundColor =
        "rgba(97 108 113 / 42%)";
      this.generateCaptcha(1, 120, 50);
      this.getUserTypeList();
      //this.checkDOB();
      this.getMemberTitle();
      this.getGenderTitle();
    },
    hideCreateAccount() {
      this.createNewAccountdiv = false;
      this.forgotPassworddiv = false;
      this.hideBg = false;
      document.getElementById("divLogin").style.backgroundColor = "";
      this.userMobile = "";
      this.userEmail = "";
      this.userPassword = "";
      this.confirmPassword = "";
      this.gender = "M";
      this.forgotLogin = "";
      this.forgotMobile = "";
      this.newPassword = "";
      this.newConfirmPassword = "";
      this.isPasswordStrenth = false;
      this.fName = "";
      this.mName = "";
      this.lName = "";
      this.dob = new Date("01 Jan 1900");
      this.captchaValue = "";
      this.forgotVerification = false;
      this.captchakeyforPwd = "";
      this.captchaValueforPwd = "";
      this.minutesLeft = 1;
      this.secondsLeft = 59;
      this.btnName = "Generate OTP";
      this.isDisabled = false;
      this.timeLeft = true;
      this.forgotOTPSend = false;
      this.forgotOTP = "";
      this.isVerifyOTPReq = false;
      this.emailOTP = "";
      this.mobileOTP = "";
      this.eMailOTPRef = "";
      this.mobileOTPRef = "";
      this.isOTPTimeLeft = false;
      this.loginName = "";
      this.loginPassword = "";
      this.loginOTP = "";
      this.loginTypeID = 1;
      this.verifyCredential = "Generate OTP";
      this.clearPage();
    },
    forgetPasswordView() {
      this.forgotPassworddiv = true;
      this.OtpForgetPassCaptchaID = 1;
      this.captchaValueForForgetPass = "";
      this.generateCaptcha(6, 120, 50);
      this.createNewAccountdiv = false;
      this.hideBg = true;
    },
    createNewUser() {
      if (!this.validateInput(1)) {
        return false;
      }
      let pwd = biometricJS.computeHash(this.userPassword);
      var createLoginParam = {
        UserID: -1,
        RankID: this.rankID,
        FName: this.fName,
        MName: this.mName,
        LName: this.lName,
        Gender: this.gender,
        DOB: this.dob.convertToString("dd MMM yyyy"),
        UserMobile: biometricJS.encryptAES(this.userMobile),
        UserEMail: biometricJS.encryptAES(this.userEmail),
        UserPassword: pwd,
        Captchakey: biometricJS.encryptAES(this.captchakey),
        CaptchaValue: biometricJS.encryptAES(
          this.captchaValue + "|~|" + this.userPassword
        ),
        ConfirmPassword: pwd,
        Type: 1,
        UserType: this.userTypeID,
        ProfileImage: "",
        ProfileImageName: "",
        ProfileImageExtention: "",
        FullAddress: "",
        CompanyName: "",
        CompanyWebSiteName: "",
        CompanyMobile: "",
        CompanyEmail: "",
        CompanyRemarks: "",

        IDType: "",
        IDDocument: ""
      };
      var formData = new FormData();
      formData.append("CreateLoginParam", JSON.stringify(createLoginParam));
      LoginJs.UpdateUserOnline(formData).then(
        response => {
          if (response.data.isSuccess) {
            this.isMobileOTPRequired = response.data.mobileOTPRequired;
            this.isEMailOTPRequired = response.data.eMailOTPRequired;
            this.verifyMobile = this.userMobile;
            this.verifyEmail = this.userEmail;
            this.eMailOTPRef = response.data.emailOTPRef;
            this.mobileOTPRef = response.data.mobileOTPRef;
            this.hideCreateAccount();
            if (
              this.isMobileOTPRequired == true ||
              this.isEMailOTPRequired == true
            ) {
              this.isOTPTimeLeft = true;
              this.isVerifyOTPReq = true;
              this.generateCaptcha(5, 120, 50);
              this.captchaValueForMobEmailVerification = "";
              this.minutesLeft = 1;
              this.secondsLeft = 59;
              this.timeLeft = true;
              this.countDownTimer();
              this.btnName = "Resend OTP";
              this.isDisabled = true;
            } else {
              alert(response.data.msg);
            }
          } else {
            this.generateCaptcha(1, 120, 50);
            alert(response.data.msg);
          }
        },
        error => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        failure => {
          alert("Failure: " + failure.response);
        }
      );
    },
    validateInput(type) {
      if (type == 1) {
        if (this.fName == null || this.fName == "") {
          alert("Please enter your first name");
          this.$refs.fName.focus();
          return false;
        }
        if (this.lName == null || this.lName == "") {
          alert("Please enter your last name");
          this.$refs.lName.focus();
          return false;
        }
        // if (
        //   this.dob == null ||
        //   this.dob == "" ||
        //   this.dob.convertToString("dd MMM yyyy") ==
        //     new Date("01 Jan 1900").convertToString("dd MMM yyyy")
        // ) {
        //   alert("Please enter your date of birth");
        //   this.$refs.dob.focus();
        //   return false;
        // }
        if (this.dob > new Date()) {
          alert("Please enter your valid date of birth");
          this.$refs.dob.focus();
          return false;
        }

        // if (
        //   this.dob < this.dOBCheckList.minDate.toDateTime() ||
        //   this.dob > this.dOBCheckList.maxDate.toDateTime()
        // ) {
        //   alert("Date of birth is not greater or less than of min or max date");
        //   return false;
        // }
        if (this.userMobile == null || this.userMobile == "") {
          alert("Please enter your mobile number");
          this.$refs.userMobile.focus();
          return false;
        }
        if (this.userMobile.startsWith("0")) {
          alert("Mobile number cannot start with 0");
          this.$refs.userMobile.focus();
          return false;
        }
        if (this.userMobile.length != "10") {
          alert("Mobile number must be 10 digits");
          this.$refs.userMobile.focus();
          return false;
        }

        if (this.userEmail == null || this.userEmail == "") {
          alert("Please enter your valid email");
          this.$refs.userEmail.focus();
          return false;
        }
        if (!this.$refs.userEmail.isValid) {
          alert("Email format is not valid");
          this.$refs.userEmail.focus();
          return false;
        }
        if (this.userPassword == null || this.userPassword == "") {
          alert("Please enter your password");
          this.$refs.userPassword.focus();
          return false;
        }
        if (this.confirmPassword == null || this.confirmPassword == "") {
          alert("Please confirm your password");
          this.$refs.confirmPassword.focus();
          return false;
        }
        if (this.userPassword != this.confirmPassword) {
          alert("Password and confirm password are mismatch");
          this.$refs.confirmPassword.focus();
          return false;
        }
        if (this.isPasswordStrenth == false) {
          alert(
            "Weak password! Password Length Must Be 8 Characters Long.Password Must Have : 1 Digit, 1 Lower Character,1 Upper Character and 1 Special Character."
          );
          return false;
        }
        if (this.captchaValue == "") {
          alert("Please enter captcha");
          return false;
        }
        return true;
      } else {
        if (this.newPassword == null || this.newPassword == "") {
          alert("Please enter your new password");
          return false;
        } else if (
          this.newConfirmPassword == null ||
          this.newConfirmPassword == ""
        ) {
          alert("Please confirm new password");
          return false;
        } else if (this.newPassword != this.newConfirmPassword) {
          alert("Password and confirm password are mismatch");
          return false;
        } else if (this.isPasswordStrenth == false) {
          alert(
            "Weak password! Password Length Must Be 8 Characters Long.Password Must Have : 1 Digit, 1 Lower Character,1 Upper Character and 1 Special Character."
          );
          return false;
        } else if (this.captchaValueforPwd == "") {
          alert("Please enter captcha");
          return false;
        } else {
          return true;
        }
      }
    },
    checkPasswordStrength(element) {
      this.isPasswordStrenth = false;
      var obj = element.currentTarget;
      var pass = obj.value;
      var lblPasswordStreingth = document.getElementById(
        "lblPasswordStreingth"
      );

      if (lblPasswordStreingth == null) {
        lblPasswordStreingth = document.createElement("div");
        lblPasswordStreingth.id = "lblPasswordStreingth";
        lblPasswordStreingth.style.backgroundColor = "white";
        lblPasswordStreingth.style.fontWeight = "bold";
        lblPasswordStreingth.style.padding = "5px";
        lblPasswordStreingth.style.position = "sticky";
        lblPasswordStreingth.style.left = "350px";
        lblPasswordStreingth.style.whiteSpace = "wrap";
        obj.parentNode.style.position = "relative";
        $(obj).after(lblPasswordStreingth);
      }
      lblPasswordStreingth.style.color = "Red";
      lblPasswordStreingth.style.border = "solid 1px red";
      var msg;
      if (pass.length < 8 && pass.length > 0) {
        msg =
          "Password Length Must Be 8 Characters Long.<br>Password Must Have : 1 Digit, 1 Lower Character,<br>1 Upper Character and 1 Special Character.";
        lblPasswordStreingth.innerHTML = msg;
      } else if (pass.length == 0) {
        lblPasswordStreingth.innerHTML = "";
        lblPasswordStreingth.style.border = "";
        lblPasswordStreingth.style.color = "";
        this.isPasswordStrenth = false;
      } else {
        var variations = {
          digits: /\d/.test(pass),
          lower: /[a-z]/.test(pass),
          upper: /[A-Z]/.test(pass),
          nonWords: /\W/.test(pass)
        };
        msg = "Password Must Have : ";
        if (variations.digits == false) {
          msg += "1 Digit,";
        }
        if (variations.lower == false) {
          msg += "1 Lower Character,";
        }
        if (variations.upper == false) {
          msg += "1 Upper Character,";
        }
        if (variations.nonWords == false) {
          msg += "1 Special Character,";
        }
        lblPasswordStreingth.innerHTML = msg;
        if (
          variations.digits &&
          variations.lower &&
          variations.upper &&
          variations.nonWords
        ) {
          lblPasswordStreingth.innerHTML = "You Have Entered Strong Password";
          lblPasswordStreingth.style.border = "solid 1px green";
          lblPasswordStreingth.style.color = "green";
          this.isPasswordStrenth = true;
        }
      }
    },
    confirmPasswordMatch(element, type) {
      var obj = element.currentTarget;
      var newPass;
      if (type == 1) {
        newPass = this.userPassword;
      } else if (type == 2) {
        newPass = this.newPassword;
      }
      var confPass = obj.value;
      var lblConfirmPassword = document.getElementById("lblConfirmPassword");
      if (lblConfirmPassword == null) {
        lblConfirmPassword = document.createElement("div");
        lblConfirmPassword.id = "lblConfirmPassword";
        lblConfirmPassword.style.backgroundColor = "white";
        lblConfirmPassword.style.fontWeight = "bold";
        lblConfirmPassword.style.padding = "5px";
        lblConfirmPassword.style.position = "sticky";
        lblConfirmPassword.style.left = "350px";
        lblConfirmPassword.style.whiteSpace = "wrap";
        obj.parentNode.style.position = "relative";
        $(obj).after(lblConfirmPassword);
      }
      var msg;
      if (confPass.length > 0) {
        if (confPass != newPass) {
          msg = "Confirm Password should be same as New Password";
          lblConfirmPassword.style.color = "Red";
          lblConfirmPassword.style.border = "solid 1px red";
          lblConfirmPassword.innerHTML = msg;
        } else if (confPass == newPass) {
          lblConfirmPassword.innerHTML = "Password matched";
          lblConfirmPassword.style.border = "solid 1px green";
          lblConfirmPassword.style.color = "green";
        }
      } else if (confPass.length == 0) {
        lblConfirmPassword.innerHTML = "";
        lblConfirmPassword.style.border = "";
        lblConfirmPassword.style.color = "";
      } else {
        lblConfirmPassword.innerHTML = "";
        lblConfirmPassword.style.border = "";
        lblConfirmPassword.style.color = "";
      }
      // if (confPass.length > 0) {
      //   if (confPass != this.newPassword) {
      //     msg = "Confirm Password should be same as New Password";
      //     lblConfirmPassword.style.color = "Red";
      //     lblConfirmPassword.style.border = "solid 1px red";
      //     lblConfirmPassword.innerHTML = msg;
      //   } else if (confPass == this.newPassword) {
      //     lblConfirmPassword.innerHTML = "Password matched";
      //     lblConfirmPassword.style.border = "solid 1px green";
      //     lblConfirmPassword.style.color = "green";
      //   }
      // } else {
      //   lblConfirmPassword.innerHTML = "";
      //   lblConfirmPassword.style.border = "";
      //   lblConfirmPassword.style.color = "";
      // }
    },
    generateCaptcha(type, w, h) {
      this.captchaValue = "";
      const _data_ = { width: w, height: h };
      LoginJs.GenerateCaptcha(_data_).then(
        response => {
          window.sessionStorage.setItem(
            "antiforgery_token",
            response.data.result2
          );
          config.AF_Token = window.sessionStorage.getItem("antiforgery_token");

          if (type == 1) {
            $("#imgCaptcha").attr("src", response.data.result1);
            this.captchakey = response.data.result;
          } else if (type == 2) {
            $("#imgCaptchaForPwd").attr("src", response.data.result1);
            this.captchakeyforPwd = response.data.result;
          } else if (type == 3) {
            $("#imgCaptchaForGetOTP").attr("src", response.data.result1);
            this.captchakeyforGetOTP = response.data.result;
            this.GetSetupData();
          } else if (type == 4) {
            $("#imgCaptchaForResendOTP").attr("src", response.data.result1);
            this.captchakeyforResendOTP = response.data.result;
          } else if (type == 5) {
            $("#imgCaptchaForMobEmailVerification").attr(
              "src",
              response.data.result1
            );
            this.captchaKeyForMobEmailVerification = response.data.result;
          } else if (type == 6) {
            $("#imgCaptchaForForgetPass").attr("src", response.data.result1);
            this.captchaKeyForForgetPass = response.data.result;
          } else if (type == 7) {
            $("#imgCaptchaForLogin").attr("src", response.data.result1);
            this.captchaKeyForLogin = response.data.result;
          }
        },
        error => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        failure => {
          alert("Failure: " + failure.response);
        }
      );
    },
    verifyForgotPasswordAuth() {
      /*
      if (this.forgotLogin == null || this.forgotLogin == "") {
        alert("Please enter your email");
        this.$ref.forgotLogin.focus();
        return false;
      } else if (this.forgotMobile == null || this.forgotMobile == "") {
        alert("Please enter your mobile number");
        this.$ref.forgotMobile.focus();
        return false;
      }
      */
      if (this.forgotMobile == null || this.forgotMobile == "") {
        alert("Please enter your mobile number");
        this.$ref.forgotMobile.focus();
        return false;
      }
      if (this.forgotMobile.startsWith("0")) {
        alert("Mobile number cannot start with 0");
        this.$refs.userMobile.focus();
        return false;
      }
      if (this.forgotMobile.length != 10) {
        alert("Mobile number must be 10 digits");
        this.$refs.userMobile.focus();
        return false;
      }
      if (this.captchaValueForForgetPass == "") {
        alert("PLEASE ENTER CAPTCHA");
        return false;
      }
      let userEMail = this.forgotLogin.trim();
      let userMobile = this.forgotMobile.trim();
      let _paramsData = {
        userEMail: userEMail,
        userMobile: userMobile,
        captchaValueForForgetPass: this.captchaValueForForgetPass,
        captchaKeyForForgetPass: this.captchaKeyForForgetPass
      };
      LoginJs.getForgetUser(_paramsData).then(
        response => {
          //console.log(response.data);
          if (response.data.isSuccess) {
            this.UserID = response.data.result.userID;
            this.forgotOTPSend = true;
            this.minutesLeft = 1;
            this.secondsLeft = 59;
            this.timeLeft = true;
            this.countDownTimer();
            this.verifyCredential = "Resend OTP";
            this.isDisabled = true;
            this.OtpCaptchaID = 1;
            this.eMailOTPRef = response.data.result.emailOTPRef;
            this.mobileOTPRef = response.data.result.mobileOTPRef;
            this.captchaValueForForgetPass = "";
            this.generateCaptcha(6, 120, 50);
            this.generateCaptcha(2, 120, 50);
          } else {
            this.captchaValueForForgetPass = "";
            this.generateCaptcha(6, 120, 50);
          }
          alert(response.data.msg);
        },
        error => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        failure => {
          alert("Failure: " + failure);
        }
      );
    },
    setNewPassword() {
      if (!this.validateInput(2)) {
        return false;
      }
      let pwd = biometricJS.computeHash(this.newPassword.trim());
      var resetPasswordParam = {
        UserID: biometricJS.encryptAES(this.UserID),
        UserEMail: biometricJS.encryptAES(this.forgotLogin.trim()),
        UserMobile: biometricJS.encryptAES(this.forgotMobile.trim()),
        UserPassword: pwd,
        UserConfirmPassword: pwd,
        CaptchaValueforPwd: biometricJS.encryptAES(
          this.captchaValueforPwd + "|~|" + this.newPassword.trim()
        ),
        CaptchakeyforPwd: biometricJS.encryptAES(this.captchakeyforPwd),
        Otp: biometricJS.encryptAES(this.forgotOTP.trim())
      };
      var formData = new FormData();
      formData.append("ResetPasswordParam", JSON.stringify(resetPasswordParam));
      LoginJs.resetPasswordOnline(formData).then(
        response => {
          alert(response.data.msg);
          if (response.data.isSuccess) {
            this.hideCreateAccount();
          } else {
            this.generateCaptcha(2, 120, 50);
          }
        },
        error => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        failure => {
          alert("Failure: " + failure);
        }
      );
    },
    countDownTimer() {
      if (this.timeLeft) {
        setTimeout(() => {
          if (this.secondsLeft > 0) {
            this.secondsLeft--;
          } else if (this.secondsLeft == 0 && this.minutesLeft >= 0) {
            this.secondsLeft = 59;
            this.minutesLeft--;
          }
          if (this.minutesLeft < 0) {
            this.secondsLeft = 0;
            this.minutesLeft = 0;
            this.timeLeft = false;
          }
          this.countDownTimer();
        }, 1000);
      } else {
        if (this.loginTypeID == 2) {
          this.OtpCaptchaID = 1;
          this.generateCaptcha(4, 80, 18);
        }
        this.isDisabled = false;
      }
    },
    verifyOTP(type) {
      let userEMail = "";
      let userMobile = "";
      let eMailOTP = "";
      let mobileOTP = "";
      if (type == 1) {
        userEMail = this.isEMailOTPRequired == 1 ? this.verifyEmail.trim() : "";
        eMailOTP = this.isEMailOTPRequired == true ? this.emailOTP.trim() : "";
        userMobile = this.verifyMobile.trim();
        mobileOTP = this.isMobileOTPRequired == 1 ? this.mobileOTP.trim() : "";
        if (this.isEMailOTPRequired == 1) {
          if (userEMail == "") {
            alert("Please enter the email");
            return false;
          }
          if (eMailOTP == "") {
            alert("Please enter the email OTP");
            return false;
          }
        }
        if (this.isMobileOTPRequired == 1) {
          if (userMobile == "") {
            alert("Please enter the mobile number");
            return false;
          }
          if (mobileOTP == "") {
            alert("Please enter the mobile OTP");
            return false;
          }
        }
      }
      if (type == 2) {
        userEMail = this.forgotLogin.trim();
        userMobile = this.forgotMobile.trim();
        eMailOTP = this.forgotOTP.trim();
        mobileOTP = this.forgotOTP.trim();

        if (userMobile == "") {
          alert("Please enter the mobile number");
          return false;
        }
        if (mobileOTP == "") {
          alert("Please enter the mobile OTP");
          return false;
        }
      }

      let _paramsData = {
        userEMail: userEMail,
        isEmailOTPReq: this.isEMailOTPRequired,
        isMobileOTPReq: this.isMobileOTPRequired,
        userMobile: userMobile,
        eMailOTP: eMailOTP,
        mobileOTP: mobileOTP,
        type: type
      };
      LoginJs.OTPVerification(_paramsData).then(
        response => {
          alert(response.data.msg);
          if (response.data.isSuccess) {
            this.eMailOTPRef = "";
            this.mobileOTPRef = "";
            if (type == 1) {
              this.isVerifyOTPReq = false;
              this.hideCreateAccount();
            } else {
              this.forgotVerification = true;
              this.generateCaptcha(2, 120, 50);
            }
            this.OtpCaptchaID = 0;
          }
        },
        error => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        failure => {
          alert("Failure: " + failure);
        }
      );
    },
    isUserActivated() {
      LoginJs.UserActivation().then(
        response => {
          this.eMailOTPRef = "";
          this.mobileOTPRef = "";
          this.isOTPTimeLeft = false;
          this.UserID = response.data.result.userID;
          this.verifyMobile = response.data.result.userMobile;
          this.verifyEmail = response.data.result.userEmail;
          {
            if (
              response.data.result.userEmail != "" ||
              response.data.result.userMobile != ""
            ) {
              if (
                (this.isEMailOTPRequired == 1 &&
                  response.data.result.isEMailActivated == 0) ||
                (this.isMobileOTPRequired == 1 &&
                  response.data.result.isMobileActivated == 0)
              ) {
                this.isVerifyOTPReq = true;
                this.generateCaptcha(5, 120, 50);
              } else {
                this.$router.push({ name: "Home" });
              }
            }
          }
        },
        error => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        failure => {
          alert("Failure: " + failure.response);
        }
      );
    },
    generateForgotOTP(type) {
      let email = "";
      let mobile = "";
      if (type == 1) {
        mobile = this.verifyMobile.trim();
        email = this.verifyEmail.trim();
        if (email == "" && this.isEMailOTPRequired == 1) {
          alert("PLEASE ENTER EMAIL");
          return false;
        }
        if (mobile == "" && this.isMobileOTPRequired == 1) {
          alert("PLEASE ENTER MOBILE NUMBER");
          return false;
        }
        if (this.captchaValueForMobEmailVerification == "") {
          alert("PLEASE ENTER CAPCHA");
          return false;
        }
      } else if (type == 2) {
        if (this.loginName == "") {
          MessageBox.show({
            message: "PLEASE ENTER MOBILE NUMBER",
            type: "error",
            title: "Error"
          });
        }
        email = this.loginName.trim();
        mobile = this.loginName.trim();
        if (this.captchaValueforResendOTP == "") {
          MessageBox.show({
            message: "PLEASE ENTER CAPCHA",
            type: "error",
            title: "Error"
          });
          return false;
        }
      } else if (type == 3) {
        if (this.forgotMobile == "") {
          MessageBox.show({
            message: "PLEASE ENTER MOBILE NUMBER",
            type: "error",
            title: "Error"
          });
        }
        if (this.captchaValueForForgetPass == "") {
          MessageBox.show({
            message: "PLEASE ENTER CAPCHA",
            type: "error",
            title: "Error"
          });
          return false;
        }
      } else {
        email = this.forgotLogin.trim();
        mobile = this.forgotMobile.trim();
      }
      let _paramsData = {};
      if (type == 2) {
        _paramsData = {
          userID: this.UserID,
          userEMail: email,
          userMobile: mobile,
          type: type,
          captchaValueforResendOTP: this.captchaValueforResendOTP,
          captchakeyforResendOTP: this.captchakeyforResendOTP
        };
      } else if (type == 1) {
        _paramsData = {
          userID: this.UserID,
          userEMail: email,
          userMobile: mobile,
          type: type,
          captchaValueforResendOTP: this.captchaValueForMobEmailVerification,
          captchakeyforResendOTP: this.captchaKeyForMobEmailVerification
        };
      } else if (type == 3) {
        _paramsData = {
          userID: this.UserID,
          userEMail: email,
          userMobile: mobile,
          type: type,
          captchaValueforResendOTP: this.captchaValueForForgetPass,
          captchakeyforResendOTP: this.captchaKeyForForgetPass
        };
      }
      LoginJs.resendOTP(_paramsData).then(
        response => {
          // console.log("aa");
          if (response.data.isSuccess) {
            if (type == 1) {
              this.generateCaptcha(5, 120, 50);
              this.eMailOTPRef = response.data.emailOTPRef;
              this.captchaValueForMobEmailVerification = "";
              this.isOTPTimeLeft = true;
              alert(response.data.msg);
            } else if (type == 2) {
              this.generateCaptcha(4, 80, 18);
              this.OtpCaptchaID = 0;
              this.captchaValueforResendOTP = "";
              FlashMessage.show(
                "<span style='color:GREEN'>" +
                  response.data.msg +
                  "</span><br/>",
                3000
              );
            } else if (type == 3) {
              this.OtpForgetPassCaptchaID = 0;
              this.forgotOTPSend = true;
              this.generateCaptcha(6, 120, 50);
              this.captchaValueForForgetPass = "";
              FlashMessage.show(
                "<span style='color:GREEN'>" +
                  response.data.msg +
                  "</span><br/>",
                3000
              );
            }
            this.UserID = response.data.userID;
            this.minutesLeft = 1;
            this.secondsLeft = 59;
            this.timeLeft = true;
            this.countDownTimer();
            this.btnName = "Resend OTP";
            this.isDisabled = true;
            this.mobileOTPRef = response.data.mobileOTPRef;
            this.IsEMailActivated = response.data.isEMailActivated;
            this.IsMobileActivated = response.data.isMobileActivated;
            // console.log("Email: " + this.IsEMailActivated);
            // console.log("Mobile: " + this.IsMobileActivated);
          } else {
            if (type == 1) {
              this.generateCaptcha(5, 120, 50);
              this.captchaValueForMobEmailVerification = "";
              alert(response.data.msg);
            } else if (type == 2) {
              FlashMessage.show(
                "<span style='color:Red'>" + response.data.msg + "</span><br/>",
                3000
              );
              this.generateCaptcha(4, 80, 18);
              this.captchaValueforResendOTP = "";
            } else if (type == 3) {
              FlashMessage.show(
                "<span style='color:Red'>" + response.data.msg + "</span><br/>",
                3000
              );
              this.generateCaptcha(6, 120, 50);
              this.captchaValueForForgetPass = "";
            }
          }
        },
        error => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        failure => {
          alert("Failure: " + failure);
        }
      );
    },
    generateForgotPasswordOTP() {
      let email = "";
      let mobile = "";
      if (this.forgotMobile == "") {
        MessageBox.show({
          message: "PLEASE ENTER MOBILE NUMBER",
          type: "error",
          title: "Error"
        });
      }
      if (this.captchaValueForForgetPass == "") {
        MessageBox.show({
          message: "PLEASE ENTER CAPCHA",
          type: "error",
          title: "Error"
        });
        return false;
      }
      email = this.forgotMobile.trim();
      mobile = this.forgotMobile.trim();

      let _paramsData = {};
      _paramsData = {
        userID: this.UserID,
        userEMail: email,
        userMobile: mobile,
        type: 2,
        captchaValueforResendOTP: this.captchaValueForForgetPass,
        captchakeyforResendOTP: this.captchaKeyForForgetPass
      };

      LoginJs.resendOTP(_paramsData).then(
        response => {
          if (response.data.isSuccess) {
            this.generateCaptcha(6, 120, 50);
            this.captchaValueForForgetPass = "";
            FlashMessage.show(
              "<span style='color:GREEN'>" + response.data.msg + "</span><br/>",
              3000
            );

            this.UserID = response.data.userID;
            this.forgotOTPSend = true;
            this.minutesLeft = 1;
            this.secondsLeft = 59;
            this.timeLeft = true;
            this.countDownTimer();
            this.isDisabled = true;
            this.mobileOTPRef = response.data.mobileOTPRef;
            this.IsEMailActivated = response.data.isEMailActivated;
            this.IsMobileActivated = response.data.isMobileActivated;

            this.OtpCaptchaID = 1;
            this.generateCaptcha(2, 120, 50);
            // console.log("Email: " + this.IsEMailActivated);
            // console.log("Mobile: " + this.IsMobileActivated);
          } else {
            FlashMessage.show(
              "<span style='color:Red'>" + response.data.msg + "</span><br/>",
              3000
            );
            this.generateCaptcha(6, 120, 50);
            this.captchaValueForForgetPass = "";
          }
        },
        error => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        failure => {
          alert("Failure: " + failure);
        }
      );
    },
    // checkDOB() {
    //   axios
    //     .get(config.WEB_API_PATH + "Login/CheckDOB", {
    //       headers: {
    //         __RequestVerificationToken: config.AF_Token,
    //         Authorization: config.LOG_Token
    //       },
    //       crossdomain: true
    //     })
    //     .then(
    //       response => {
    //         this.dOBCheckList = response.data.result;
    //         console.log(this.dOBCheckList);
    //       },
    //       error => {
    //         if (error.response.data.message != undefined) {
    //           alert(
    //             error.response.data.message +
    //               "\n" +
    //               error.response.data.exceptionMessage
    //           );
    //         } else {
    //           alert("Error: " + error.response.data);
    //         }
    //       },
    //       failure => {
    //         alert("Failure: " + failure.response);
    //       }
    //     );
    // },
    checkBrowserVersion(target, msgTarget) {
      //let nVer = navigator.appVersion;
      let nAgt = navigator.userAgent;
      let browserName = navigator.appName;
      let fullVersion = "" + parseFloat(navigator.appVersion);
      let majorVersion = parseInt(navigator.appVersion, 10);
      let nameOffset, verOffset, ix;

      // In Opera 15+, the true version is after "OPR/"
      if ((verOffset = nAgt.indexOf("OPR/")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 4);
      }
      // In older Opera, the true version is after "Opera" or after "Version"
      else if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1) {
          fullVersion = nAgt.substring(verOffset + 8);
        }
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "MSIE";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      // In Chrome, the true version is after "Chrome"
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Safari, the true version is after "Safari" or after "Version"
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1) {
          fullVersion = nAgt.substring(verOffset + 8);
        }
      }
      // In Firefox, the true version is after "Firefox"
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      }
      // In most other browsers, "name/version" is at the end of userAgent
      else if (
        (nameOffset = nAgt.lastIndexOf(" ") + 1) <
        (verOffset = nAgt.lastIndexOf("/"))
      ) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix);
      if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix);

      majorVersion = parseInt("" + fullVersion, 10);
      if (isNaN(majorVersion)) {
        fullVersion = "" + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }
      let html = "";
      html += "Browser name  = " + browserName + "<br>";
      html += "Full version  = " + fullVersion + "<br>";
      html += "Major version = " + majorVersion + "<br>";
      //html += 'navigator.appName = ' + navigator.appName + '<br>';
      //html += 'navigator.userAgent = ' + navigator.userAgent + '<br>';
      if (target) {
        //target.innerHTML = html;
        if (browserName == "Opera" && majorVersion < 60) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        } else if (browserName == "MSIE" && majorVersion < 11) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        } else if (browserName == "Chrome" && majorVersion < 60) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        } else if (browserName == "Safari" && majorVersion < 14) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        } else if (browserName == "Firefox" && majorVersion < 60) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        } else if (browserName == "Netscape" && majorVersion < 5) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        }
      }
    },
    getUserTypeList() {
      const _data_ = { isActive: 1, type: 1 };
      LoginJs.getUserType(_data_).then(
        response => {
          this.userTypeList = response.data;
          this.userTypeID = response.data[0].userTypeID;
        },
        error => {}
      );
    },
    getMemberTitle() {
      const _data_ = { rankID: -1, isActive: 1, type: 1 };
      LoginJs.getRank(_data_).then(
        response => {
          this.memberTitleList = response.data;
          this.rankID = response.data[0][0];
          //console.log(this.memberTitleList);
        },
        error => {}
      );
    },
    getGenderTitle() {
      const _data_ = { genderID: -1, isActive: 1, type: 1 };
      LoginJs.GetGenderList(_data_).then(
        response => {
          this.genderList = response.data;
          this.genderCode = response.data[0][2];
          //console.log(this.genderList);
        },
        error => {}
      );
    },
    sendOTP() {
      if (this.loginName == "") {
        FlashMessage.show(
          "<span style='color:Red'>PLEASE ENTER MOBILE NUMBER</span><br/>",
          3000
        );
        return;
      }
      if (this.loginName.length < 10) {
        FlashMessage.show(
          "<span style='color:Red'>PLEASE ENTER VALID MOBILE NUMBER</span><br/>",
          3000
        );
        return;
      }
      if (this.captchaValueforGetOTP == "") {
        FlashMessage.show(
          "<span style='color:Red'>PLEASE ENTER CAPTCHA</span><br/>",
          3000
        );
        return false;
      }
      if (!this.validEmail(this.loginName)) {
        FlashMessage.show(
          "<span style='color:Red'>PLEASE ENTER CORRECT MOBILE NUMBER</span><br/>",
          3000
        );
        return false;
      }
      const sendOTPParams = {
        UserMobile: this.loginName,
        IsMobile: 1,
        type: 1,
        CaptchaValueforGetOTP: this.captchaValueforGetOTP,
        CaptchakeyforGetOTP: this.captchakeyforGetOTP
      };
      var formData = new FormData();
      formData.append("SendOTPParams", JSON.stringify(sendOTPParams));
      LoginJs.generateLoginOTP(formData).then(
        result => {
          //console.log(result.data);
          if (result.data.isSuccess) {
            FlashMessage.show(
              "<span style='color:GREEN'>" + result.data.msg + "</span><br/>",
              3000
            );
            this.UserID = result.data.result;
            this.minutesLeft = 1;
            this.secondsLeft = 59;
            this.timeLeft = true;
            this.countDownTimer();
            this.isDisabled = true;
            this.loginTypeID = 2;
            vue.nextTick(() => {
              document.getElementById("txtOTP").focus();
            });
          } else {
            this.captchaValueforGetOTP = "";
            this.generateCaptcha(3, 100, 17);
            FlashMessage.show(
              "<span style='color:Red'>" + result.data.msg + "</span><br/>",
              3000
            );
          }
        },
        error => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        failure => {
          alert("Failure: " + failure);
        }
      );
    },
    GetSetupData() {
      const _data_ = {};
      MasterJS.getSetupData().then(
        response => {
          this.SetupData = response.data;
          this.isMobileOTPRequired = response.data[0][6];
          this.isEMailOTPRequired = response.data[0][7];
        },
        error => {}
      );
    },
    validEmail(value) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        return false;
      } else if (/^[56789]\d{9}$/.test(value)) {
        return true;
      }
    }
  },
  mounted() {
    if (this.$root.$data.sessionPage != undefined) {
      this.$router.go();
    }
    window.sessionStorage.removeItem("token");
    window.sessionStorage.removeItem("token_type");
    window.sessionStorage.removeItem("refresh_token");
    window.sessionStorage.removeItem("antiforgery_token");

    this.generateCaptcha(3, 100, 17);
    ekkJS.setDateControls();
    this.checkBrowserVersion(
      document.getElementById("divBrowserInfo"),
      document.getElementById("divBrowserNotSupported")
    );
    // $("[DefaultButton]")
    //   .off("keypress")
    //   .on("keypress", function (e) {
    //     if (e.which == 13) {
    //       var DefaultButton = this.getAttribute("DefaultButton");
    //       if (DefaultButton && e.target.id !== DefaultButton) {
    //         $("#" + DefaultButton, this).click();
    //       }
    //     }
    //   });
    //window.setTimeout(() => {
    //}, 500);
  }
};
</script>
<style scoped>
.instructionRow {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 18px;
  font-size: 13px;
  margin-bottom: 6px;
  /* border-bottom: solid thin darkgrey; */
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .imgHeight {
    height: 160px;
  }

  @media screen and (max-width: 480px) {
    .imgHeight {
      height: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue